<template>
  <div class="form-group">
    <label>{{ question.statement }}</label>
    <date-picker
      :value="getAnswerAsDateObject()"
      placeholder="Selecione a data"
      :bootstrapStyling="true"
      :language="datepickerLanguage"
      :required="question.required"
      :disabled="disabledAttribute"
      :disabled-dates="disabledDates"
      @selected="onDateSelected">
    </date-picker>
    <p class="text-red" v-if="m_error">{{ m_error }}</p>
  </div>
</template>

<script>
  import DatePicker from 'vuejs-datepicker'
  import { ptBR } from 'vuejs-datepicker/dist/locale'
  import DateFormatter from '@/services/date_formatter'

  export default {
    props: ['question', 'answer', 'isDisabled', 'disableFutureDates'],
    name: 'DateQuestion',
    components: { DatePicker },
    data () {
      return {
        datepickerLanguage: ptBR,
        m_question: this.question,
        m_answer: {
          questionUuid: this.question.uuid,
          value: this.answer ? this.answer.value : null
        },
        m_error: null
      }
    },
    computed: {
      disabledAttribute () {
        return this.question.disabled === true || this.isDisabled === true
      },
      disabledDates () {
        if (this.disableFutureDates) {
          return {
            from: new Date()
          }
        }
        return {}
      }
    },
    watch: {
      'm_answer.value' () {
        this.$emit('answerUpdated', this.m_answer)
      }
    },
    methods: {
      getAnswerAsDateObject () {
        if (!this.answer.value) {
          return null
        }
        return new Date(this.answer.value.split('-'))
      },
      onDateSelected (date) {
        this.m_answer.value = DateFormatter.formatAPIDate(date)
      },
      isValid () {
        if (this.question.required && !this.m_answer.value) {
          this.m_error = 'Este campo é de preenchimento obrigatório.'
          return false
        }
        this.m_error = null
        return true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DateQuestion.vue?43c436f7